import script from "./AchievementProgressBar.vue?vue&type=script&setup=true&lang=js"
export * from "./AchievementProgressBar.vue?vue&type=script&setup=true&lang=js"

import "./AchievementProgressBar.vue?vue&type=style&index=0&id=7145893e&lang=scss&scoped=true"

import exportComponent from "/PPPoker/kkpoker-anniversary/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7145893e"]])

export default __exports__